import oosiComponent from './out-of-stock-indicator.component'

const module = angular.module('mpa.components.oosi', [])

module.component('outOfStockIndicator', oosiComponent)

export default module.name
